import {SwalAlertClass} from "core/swalClass";
import axiApi from "ApiCaller";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";
import DateDisplay from "components/datetime/DateDisplay";

const TableExports = ({items, itemsShow, checkboxAll, setCheckboxAll, onClickCheckbox}) => {
    const {t: _Tr} = useTranslation("routes");
    const {t: tC} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    // -
    const handClickAll = (e) => {
        let checkboxes = document.querySelectorAll("#tbody-table-exports input[type='checkbox']");
        if (e.target.checked) {
            checkboxes.forEach((item) => {
                item.checked = true;
                items.current.chosen.push(item.value);
                items.current.checkboxes.push(item);
            });
            setCheckboxAll(true);
        } else {
            checkboxes.forEach((item) => {
                item.checked = false;
                items.current.chosen = [];
                items.current.checkboxes = [];
            });
            setCheckboxAll(false);
        }
    };
    // -
    const onClickLink = (e) => {
        let link = e.target.dataset.link;
        if (!link) {
            Alert.error("Archivo", "No se pudo encontrar la referencia del archivo");
            return false;
        }
        axiApi
            .get(link, {
                responseType: "blob",
            })
            .then((resp) => {
                const contentDisposition = resp.headers["content-disposition"];
                const contentType = resp.headers["content-type"];
                let filename = "downloaded-file";
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
                const blob = new Blob([resp.data], {type: contentType});
                const urlBlob = window.URL.createObjectURL(blob);
                const linkTemp = document.createElement("a");
                linkTemp.href = urlBlob;
                linkTemp.setAttribute("download", filename);

                document.body.appendChild(linkTemp);
                linkTemp.click();
                document.body.removeChild(linkTemp);
            })
            .catch((error) => {
                console.log(error);
                Alert.error("Error", "Al descargar el archivo, se produjo un error: " + error.message);
            });
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "163px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th key="-1" style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            name="all"
                            type="checkbox"
                            checked={checkboxAll}
                            onChange={handClickAll}
                        />
                    </th>
                    {/* <th>Finalizada</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th>Archivo</th>
                    <th>Tamaño</th> */}
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {tC("table.finished")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {tC("table.name")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {tC("table.description")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {tC("table.file")}
                    </th>
                    <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        {tC("table.size")}
                    </th>
                </tr>
            </thead>
            <tbody id="tbody-table-exports">
                {itemsShow.map((item, index) => (
                    <tr key={index}>
                        <td>
                            <input type="checkbox" value={index} onClick={onClickCheckbox} />
                        </td>
                        <td>
                            <DateDisplay date={item.ended_at} title={true} />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>
                            <button type="button" data-link={item.link} className="btn btn-link p-0 m-0" onClick={onClickLink}>
                                Descargar {item.filename}
                            </button>
                        </td>
                        <td>{item.size}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableExports;
